<!--
    文件描述：页头、页尾
    创建人：殷俊
    创建时间：2022-07-11
-->
<template>
    <div>
        <header class="header">
            <img class='logo' src="@/assets/images/home/logo.png" @click="goStoreHome">
            <span class="search">
                <input placeholder="商品名称">
                <img src="@/assets/images/store/home/search.png">
            </span>
            <div class="headImgDiv" @mouseenter="showMenuList" @mouseleave="hideMenuList" @click="goMy">
                <img src="@/assets/images/store/home/head.png">
            </div>
            <span class="login" @click="showLoginPop">登录</span>
        </header>
        <div class="main">
            <router-view/>
        </div>
        <footer class="footer">
            <div class="infoArea">
                <span class="left">
                    <div>
                        <span>商务： 陈鑫&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                        <span>电话： 13770761846</span>
                    </div>
                    <div>邮箱： chenxin@skywellcorp.com</div>
                    <div>地址： 江苏省南京市江宁区苏源大道19号九龙湖国际企业总部园B1栋12楼</div>
                </span>
                <span class="right">
                    <span class='officialAccounts'>
                        <img src="@/assets/images/home/officialAccounts.png">
                        <div>公众号</div>
                    </span>
                    <span class='qrCode'>
                        <img src="@/assets/images/home/qrCode.png">
                        <div>二维码</div>
                    </span>
                </span>
            </div>
            <div class="copyRight">版权所有： Copyright@gongkongbpo.com 经营许可证编号： 京B2-20190088 电信业务审批【2014】字第180号</div>
        </footer>

        <!-- menuList -->
        <div v-show='isShowMenuList' class="menuList" @mouseenter="showMenuList" @mouseleave="hideMenuList">
            <ul>
                <li @click="goMy">东方小白</li>
                <li @click="goMyShopping">购物车</li>
                <li @click="goOrder">我的订单</li>
                <li @click="goMyCollect">我的收藏</li>
            </ul>
        </div>

        <!-- 购物车、客服悬浮框 -->
        <div class="shoppingAndContact">
            <div @click="goMyShopping">
                <img src="@/assets/images/store/home/shopping.png">
            </div>
            <div @click="contactUs">
                <img src="@/assets/images/store/home/contact.png">
            </div>
        </div>

        <!-- 登录弹框 -->
        <div v-show='isShowLoginPop' class="loginPop">
            <div class="title">登录</div>
            <input class="phone" placeholder="请输入手机号">
            <div class="code">
                <input placeholder="请输入动态密码">
                <div>获取动态码</div>
            </div>
            <button class="loginBtn">登录</button>
            <img class='close' src="@/assets/images/common/pic-close.png" @click="closeLoginPop">
        </div>

        <!-- 通用弹框 -->
        <Dialog v-show='dialog.data.show'></Dialog>

    </div>
</template>

<script>
import Dialog from '@/components/Dialog'
export default {
    name: 'home',
    components: {
        Dialog
    },
    data() {
        return {
            dialog: this.$rv_dialog, // 弹出框
            isShowLoginPop: false,
            isShowMenuList: false
        }
    },

    mounted() {
        this.initPage();
    },

    methods: {
        /**
         * 初始化页面
         * @param
         * @return
         */
        initPage () {
            let html = document.documentElement;
            let wW = html.clientWidth; // 窗口宽度
            // 台式机、笔记本按px显示，再小的设备按比例显示
            if(wW >= 1250) {
                document.documentElement.style.fontSize = 100 + 'px';
            }

            // 移动端微信、qq浏览器提示横屏观看
            let isMobile = this.$rv_common.isMobile();
            if(isMobile) {
                let orientation = window.orientation;
                // 横屏
                if((orientation != 90) && (orientation != -90)) {
                    this.$rv_dialog.alert('为了确保体验，请在PC端或横屏下浏览！', '确定', () => {

                    })
                }
            }
            let _this = this;
            // 横竖屏切换事件
            window.addEventListener('orientationchange', function() {
                _this.$router.go(0); // 刷新
            });
        },

        /**
         * 弹出--登录弹框
         * @param
         * @return
         */
        showLoginPop() {
            this.isShowLoginPop = true;
        },

        /**
         * 关闭--登录弹框
         * @param
         * @return
         */
        closeLoginPop() {
            this.isShowLoginPop = false;
        },

        /**
         * 显示--下拉菜单
         * @param
         * @return
         */
        showMenuList() {
            this.isShowMenuList = true;
        },

        /**
         * 隐藏--下拉菜单
         * @param
         * @return
         */
        hideMenuList() {
            this.isShowMenuList = false;
        },

        /**
         跳转--我的购物车
         @param
         @return
         */
        goMyShopping() {
            this.$router.push({path: '/store/shopping'});
        },

        /**
         跳转--我的购物车
         @param
         @return
         */
        contactUs() {
            window.open('https://kefu.ywkefu.com/chat/api/chatGroup/h5/600');
        },

        /**
         跳转--商城首页
         @param
         @return
         */
        goStoreHome() {
            this.$router.push({path: '/store/firstPage'});
        },

        /**
         跳转--我的页面
         @param
         @return
         */
        goMy() {
            this.$router.push({path: '/store/my'});
        },

        /**
         * 跳转--订单页
         * @param
         * @return
         */
        goOrder() {
            this.$router.push({path: '/store/my'})
        },

        /**
         * 跳转--我的收藏
         * @param
         * @return
         */
        goMyCollect() {
            this.$router.push({path: '/store/myCollect'})
        }
    }
}
</script>

<style lang="less" scoped>
.header {
    position: relative;
    height: 0.8rem;
    background-color: white;
    >.logo {
        position: absolute;
        top: 0.07rem;
        left: 18.75%;
        width: 3.37rem;
        height: 0.67rem;
        cursor: pointer;
    }

    >.search {
        position: absolute;
        top: 0.25rem;
        right: 24.11%;
        border: 0.01rem solid #E5E5E5;
        border-radius: 0.20rem;
        padding: 0.02rem 0.05rem;
        width: 3.00rem;
        >input {
            margin-left: 0.08rem;
            width: 2.55rem;
            height: 0.3rem;
        }

        >img {
            position: absolute;
            top: 0.08rem;
            right: 0.15rem;
            width: 0.2rem;
            height: 0.2rem;
        }
    }

    >.headImgDiv {
        position: absolute;
        top: 0.18rem;
        right: 16%;
        width: 1rem;
        height: 0.6rem;
        text-align: center;
        >img {
            width: 0.5rem;
            height: 0.5rem;
            cursor: pointer;
        }
    }
    >.login {
        position: absolute;
        top: 0.32rem;
        right: 15%;
        cursor: pointer;
    }
}

.footer {
    position: relative;
    height: 4.00rem;
    background: url(../../assets/images/home/footerBg.png) no-repeat center center;
    background-size: 100% 100%;
    color: #ffffff;
    >.infoArea {
        position: absolute;
        top: 2.09rem;
        left: 0;
        right: 0;
        margin: 0 auto;
        width: 12.00rem;
        >.left {
            >div {
                margin-bottom: 0.10rem;
            }
        }
        >.right {
            position: absolute;
            top: -0.65rem;
            right: 0;
            text-align: center;
            >.officialAccounts {
                float: left;
                margin-right: 0.58rem;
                >img {
                    width: 1.10rem;
                    height: 1.10rem;
                }
                >div {
                    margin-top: 0.10rem;
                    font-size: 0.14rem;
                }
            }
            >.qrCode {
                float: right;
                >img {
                    width: 1.10rem;
                    height: 1.10rem;
                }
                >div {
                    margin-top: 0.10rem;
                    font-size: 0.14rem;
                }
            }
        }
    }
    .copyRight {
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0.30rem;
        margin: 0 auto;
        width: 12.00rem;
        text-align: center;
    }
}

.loginPop {
    position: absolute;
    top: 30%;
    left: 0;
    right: 0;
    margin: 0 auto;
    padding: 0.23rem 0.40rem;
    width: 4rem;
    height: 3.20rem;
    background: #FFFFFF;
    border: 4px solid rgba(26, 57, 106, 0.2);
    border-radius: 2px;
    text-align: center;
    >.title {
        font-size: 24px;
        font-weight: bold;
        color: #333333;
    }
    >.phone {
        margin-top: 0.2rem;
        padding: 0 0.1rem;
        border: 0.01rem solid #D1D1D1;
        width: 3.2rem;
        height: 0.48rem;
        outline: 0;
    }
    >.code {
        position: relative;
        margin: 0.22rem auto 0 auto;
        width: 3.20rem;
        height: 0.48rem;
        border: 0.01rem solid #D1D1D1;
        >input {
            position: absolute;
            left: 0;
            padding: 0 0.1rem;
            width: 2.15rem;
            height: 100%;
            border: none;
            outline: 0;
        }
        >div {
            position: absolute;
            right: 0;
            padding: 0 0.1rem;
            height: 100%;
            line-height: 0.48rem;
            font-size: 0.14rem;
            color: #666666;
            background: #E5E5E5;
            cursor: pointer;
        }
    }
    >.loginBtn {
        margin-top: 0.31rem;
        width: 3.20rem;
        height: 0.48rem;
        background: #1A396A;
        border: none;
        border-radius: 0.02rem;
        font-size: 0.18rem;
        color: #fff;
    }
    >.close {
        position: absolute;
        top: 0;
        right: 0;
        margin: -0.15rem -0.15rem 0 0;
        width: 0.4rem;
        height: 0.4rem;
    }
}

.menuList {
    position: absolute;
    top: 0.7rem;
    right: 15%;
    padding: 0.1rem 0.15rem;
    background-color: #fff;
    >ul {
        >li {
            margin-top: 0.11rem;
            cursor: pointer;
            color: #666666;
        }

        >li:before {
            position: relative;
            top: 0.03rem;
            margin-right: 0.1rem;
        }
        >li:nth-child(1):before {
            content: url(../../assets/images/store/home/menuList/my.png);
        }
        >li:nth-child(2):before {
            content: url(../../assets/images/store/home/menuList/shopping.png);
        }
        >li:nth-child(3):before {
            content: url(../../assets/images/store/home/menuList/order.png);
        }
        >li:nth-child(4):before {
            content: url(../../assets/images/store/home/menuList/collect.png);
        }

        >li:hover {
            color: #1A396A;
        }

        >li:nth-child(1):hover:before {
            content:url(../../assets/images/store/home/menuList/mySel.png);
        }
        >li:nth-child(2):hover:before {
            content:url(../../assets/images/store/home/menuList/shoppingSel.png);
        }
        >li:nth-child(3):hover:before {
            content:url(../../assets/images/store/home/menuList/orderSel.png);
        }
        >li:nth-child(4):hover:before {
            content:url(../../assets/images/store/home/menuList/collectSel.png);
        }
    }
}

//.main {
//    height: calc(100vh - 5.35rem);
//    background-color: #1a396a;
//}

.shoppingAndContact {
    position: fixed;
    right: 32px;
    bottom: 15%;
    cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/page/sys/storeHome.vue